import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from '../state.service';
import { AlertService } from '../alert.service';
import { ToastService } from '../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

@Injectable()
export class ApiActionLogsService extends ApiBaseService {

  protected headers: Headers;
  isLoading: boolean = true;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  /**
   * @param params 
   * @return void
   */
  list(params = {}): Promise<any> {
    let queryString = this.getQueryString(params);
    let url = `${this.apiAuthStore.url}/api/v1/actionLogs?${queryString}`;
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.headers}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  // 睡眠ログ取得
  listSleepLogs(params = {}): Promise<any> {
    let queryString = this.getQueryString(params);
    let url = `${this.apiAuthStore.url}/api/v1/actionLogs?${queryString}`;
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({url: url, body: {}, headers: this.headers}
      ).finally(() => this.isLoading = false
      ).subscribe(response => resolve(response))
    });
  }

  // ナースコールログ取得
  listNurseCallLogs(params = {}): Promise<any> {
    let queryString = this.getQueryString(params);
    let url = `${this.apiAuthStore.url}/api/v1/actionLogs?${queryString}`;
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({url: url, body: {}, headers: this.headers}
      ).finally(() => this.isLoading = false
      ).subscribe(response => resolve(response))
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-action-logs.service.ts